import React, { useEffect, useMemo, useState } from 'react';

import { QuestionTimeDefaultProps, QuestionTimePropTypes } from 'src/components/JobDatasheet/propTypes';
import { timeMask, toMilitaryTimeString } from 'src/utils/format/time';
import { EiqInput } from 'eiq-storybook';
import s from 'src/components/JobDatasheet/JobDatasheetForm/JobDatasheetForm.styles';

export const QuestionTime = ({
  isRectifiedQuestion,
  question,
  onChange,
  readonly,
  value,
  disableChange,
}) => {
  const selectedValueKey = isRectifiedQuestion ? 'rectifiedValue' : 'value';
  const [currentValue, setCurrentValue] = useState(value ? toMilitaryTimeString(value[selectedValueKey]) : '');
  const [error, setError] = useState(null);

  const pattern = useMemo(() => new RegExp(/^([0-1]?\d|2[0-4]):([0-5]\d)?$/), []);

  useEffect(() => {
    setCurrentValue(value ? toMilitaryTimeString(value[selectedValueKey]) : '');
  }, [value?.value, value?.rectifiedValue]);

  const onBeforeMaskedStateChange = ({ nextState }) => {
    return timeMask(nextState, readonly);
  };

  const onInputChange = e => {
    if (!readonly) {
      setCurrentValue(e.target.value);
    }
  };

  const onBlur = () => {
    if (value?.value === currentValue) {
      return;
    }

    const returnObject = {
      ...value,
      type: 'time'
    };

    if (pattern.test(currentValue)) {
      setError(null);
      returnObject[selectedValueKey] = currentValue;

      onChange(returnObject);
    } else if (currentValue === '__:__'||currentValue.trim()==='') {
      setError(null);
      returnObject[selectedValueKey] = '';

      onChange(returnObject);
    } else {
      setError('Invalid format');
    }
  };

  return (
    <s.QuestionNumberPercentTimeWrapper>
    <EiqInput 
    type='time'
    beforeMaskedStateChange={onBeforeMaskedStateChange}
    defaultValue={currentValue || ''}
    error={error}
    id={`question-time-input-${question?.id}`}
    wrapperClassName={'eiqInput'}
    fullsize={'true'}
    mask={readonly ? null : [/[0-2]/, /\d/, ':', /[0-5]/, /\d/]}
    onBlur={() => !readonly && onBlur()}
    onChange={!disableChange && onInputChange}
    value={currentValue || ''}
    />
  </s.QuestionNumberPercentTimeWrapper>
  );
};

QuestionTime.propTypes = QuestionTimePropTypes;
QuestionTime.defaultProps = QuestionTimeDefaultProps;
